import { isEmpty } from "lodash";
import React from "react";
import { StyledTable } from "./base";
import { TableHeaders } from "./Head";

export type TableProps<K extends PropertyKey> = {
  fields: TableHeaders<K>;
  filters?: Partial<Record<K, React.ReactNode>>;
};

export function TableFilter<T extends PropertyKey>({ fields, filters = {} }: TableProps<T>) {
  if (isEmpty(filters)) return null;
  return (
    <StyledTable.Row key="filters" even>
      {fields.map(({ name }: { name: T }, index) => {
        const comp = filters[name];
        return (
          <StyledTable.Cell
            key={name.toString()}
            align={index > 0 ? "right" : "left"}
          >
            {comp || null}
          </StyledTable.Cell>
        );
      })}
    </StyledTable.Row>
  );
}